const PHRASE = ["FIX IT.", "FIT N FIX.", "SORTED.", "SWANSEA'S HANDYMAN.", "£60 MINIMUM.", "NO SURPRISES."];

export const Marquee = ({ reverse = false, bg = "#0A1A4A", fg = "#2563EB" }) => {
  const items = [...PHRASE, ...PHRASE, ...PHRASE, ...PHRASE];
  return (
    <div className="overflow-hidden border-y-2 border-[#0A1A4A] py-4" style={{ background: bg }} data-testid="marquee">
      <div className={`marquee-track ${reverse ? "reverse" : ""}`}>
        {items.map((t, i) => (
          <span key={i} className="font-display font-black text-2xl sm:text-4xl uppercase tracking-tight px-6 flex items-center gap-6" style={{ color: i % 2 === 0 ? fg : "#FFFFFF" }}>
            {t}
            <span className="text-[#EAB308] text-xl">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
};
